import { css } from '@emotion/react'
import { IContentfulCategory } from 'api/contentful/contentful.types'
import { getArticleList, IArticleListItem } from 'api/contentful/getArticleList'
import { getCategoryList } from 'api/contentful/getCategories'
import { ArticleList } from 'components/articles/articleList/ArticleList'
import { Block } from 'components/Block'
import { Footer } from 'components/footer/Footer'
import { TopNavigationLandingPage } from 'components/header/topNavigationLandingPage/TopNavigationLandingPage'
import { Layout } from 'components/layout/Layout'
import { PageMeta } from 'components/PageMeta'
import { PageTitle } from 'components/PageTitle'
import { GetStaticProps } from 'next'
import { useTranslation } from 'next-i18next'
import { useEffect } from 'react'
import { mutateAnalyticsData } from 'utils/analytics'
import { REVALIDATE_SECS } from 'utils/constants'
import { getIntlProps } from 'utils/i18n/getIntlProps'

export default function Page({
  articles,
  categories,
}: {
  articles: IArticleListItem[]
  categories: IContentfulCategory[]
}) {
  const { t } = useTranslation()
  useEffect(() => {
    mutateAnalyticsData({ page: 'articles' })
  }, [])

  return (
    <Layout
      header={<TopNavigationLandingPage variant="general-info" />}
      footer={<Footer variant="estate-planning" />}
    >
      <PageTitle title={t('common.articles.page.meta_title')} />
      <PageMeta description={t('common.articles.page.meta_description')} />

      <Block css={{ overflow: 'hidden' }}>
        <div
          css={css`
            padding-top: 2.25rem;
            padding-bottom: 7.5rem;
          `}
        >
          <ArticleList initialArticles={articles} initialCategories={categories} />
        </div>
      </Block>
    </Layout>
  )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  const articles = await getArticleList()
  const categories = await getCategoryList()
  return {
    props: { ...(await getIntlProps(ctx)), articles, categories },
    revalidate: REVALIDATE_SECS,
  }
}
